export default __webpack_public_path__ + "static/media/wireless-bluetooth-2.f7277636.png";